<template>
    <div class="layout gsc-layout">
      <Row>
        <Col span="24">
          <Card class="index-con">
            <p slot="title" class="card-title">
              {{$t('index.route.t1')}}
            </p>
            <div class="commission-list">
                <div class="item" v-for="(item, key) in commissionList" :key="key" :style="{width: 100 / commissionList.length + '%'}" @click="goRouter(item.router)">
                  <div class="item-content">
                    <icon :class="['icon', item.icon]"></icon>
                    <p class="f1">{{item.value}}</p>
                    <p class="f2">{{item.name}}</p>
                  </div>
                </div>
            </div>
          </Card>
        </Col>
      </Row>
      <Row style="margin:10px -5px 10px;">
        <Col span="12" style="padding:0 5px;">
          <Card class="index-con">
            <p slot="title" class="card-title">
              {{$t('index.common.announcement')}} <a href="javascript:;" @click="goNotification">{{$t('index.common.more')}}&gt;&gt;</a>
            </p>
            <div class="notification-list">
              <Spin fix v-if="notificationLoading"></Spin>
              <ul>
                <li v-for="(item, index) in notificationList" :key="index" :style="{ color: item.CHECK_CNT === 0 ? '#000' : '#999' }" @click="goNotificationDetail(item)">
                  <div class="content">{{item.noticeTitle}}</div>
                  <span class="time">{{item.publishTime}}</span>
                </li>
              </ul>
            </div>
          </Card>
        </Col>
        <Col span="12" style="padding:0 5px;">
          <Card class="index-con">
            <p slot="title" class="card-title">
              {{$t('index.common.download')}}
            </p>
            <ul class="download-list">
              <li @click="download('17a36a26e9529b2d48884e74f8a850dc', '17a36b6cae615d1035c646e4d08a19d4')">{{$t('index.common.word1')}}</li>
              <li @click="download('17a36a318ff6414feb6d7704277b9c66', '')">{{$t('index.common.word3')}}</li>
              <li @click="download('17a36a38bc78c15c46af7334c9894ce2', '17a36b71248f2c21835d7ec490995ab3')">{{$t('index.common.word2')}}</li>
              <li v-for="item in INT_INDEX_FILES" :key="item.value" @click="downloadFile(item.value)">{{item.label}}</li>
            </ul>
          </Card>
        </Col>
      </Row>
    </div>
</template>
<style scoped lang='less'>
  /deep/ .gsc-layout .m-card-head {
    padding: 5px 16px;
  }
  .layout{
    padding: 10px;
  }
  .index-con {
    height: 270px;

  }
  .commission-list {
    overflow: hidden;
    .item {
      float: left;
      padding: 10px;
      text-align: center;
      cursor: pointer;
      .item-content {
        padding: 20px 10px 0;
        background: #FFF;
        box-shadow: 0 2px 5px 0 rgba(34,37,56,0.05);
        border-radius: 2px;
        border-radius: 2px;
        height: 170px;
      }
      .f1 {
        font-size: 36px;
      }
      .f2 {
        font-size: 14px;
        color: #8C8C8C;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
      .icon {
        display: inline-block;
        width: 52px;
        height: 52px;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center;;
      }
      .icon1 {
        background-image: url('../../../assets/icons/icon1.svg');
      }
      .icon2 {
        background-image: url('../../../assets/icons/icon2.svg');
      }
      .icon3 {
        background-image: url('../../../assets/icons/icon3.svg');
      }
      .icon4 {
        background-image: url('../../../assets/icons/icon4.svg');
      }
      .icon5 {
        background-image: url('../../../assets/icons/icon5.svg');
      }
      .icon6 {
        background-image: url('../../../assets/icons/icon6.svg');
      }
      .icon7 {
        background-image: url('../../../assets/icons/icon12.svg');
      }
      .icon8 {
        background-image: url('../../../assets/icons/icon8.svg');
      }
      .icon9 {
        background-image: url('../../../assets/icons/icon9.svg');
      }
      .icon10 {
        background-image: url('../../../assets/icons/icon10.svg');
      }
      .icon11 {
        background-image: url('../../../assets/icons/icon11.svg');
      }
      .icon12 {
        background-image: url('../../../assets/icons/icon12.svg');
      }
  }
  .index-msg-list {
    li {
      float: left;
      line-height: 30px;
      cursor: pointer;
      span {
        margin-left: 5px;
        color: #F00;
      }
    }
    li:nth-child(odd) {
      width: 50%;
    }
    :nth-child(even) {
      width: 50%;
    }
  }
  .card-title a {
    float: right;
    font-size: 12px;
    color: #999;
  }
  .notification-list {
    position: relative;
    line-height: 30px;
    height: 200px;
    overflow: auto;
    li {
      cursor: pointer;
      height: 30px;
      position: relative;
      padding-right: 120px;
      font-size: 13px;
      .content {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .time {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  .download-list {
    li {
      font-size: 14px;
      line-height: 40px;
      padding-left:30px;
      background: url('../../../assets/icons/icon7.svg') no-repeat 0 center;
      background-size:auto 60%;
      cursor: pointer;
    }
  }
</style>
<script>
import axios from 'axios';
import moment from 'moment';
import { replaceHostName } from '@/utils/index';

export default {
  data() {
    return {
        INT_INDEX_FILES: [],
      notificationList: [],
      notificationLoading: false,
      commissionList: [
        {
          name: this.$t('index.common.t1'),
          value: 0,
          icon: 'icon3',
          router: 'deliveryNoticeConfirm'
        },
        {
          name: this.$t('index.common.t2'),
          value: 0,
          icon: 'icon4',
          router: 'createDeliveryOrderToInformView'
        }
        // {
        //   name: this.$t('index.common.t3'),
        //   value: 0,
        //   icon: 'icon5',
        //   router: 'createDeliveryOrderByOrder'
        // }
      ]
    };
  },
  methods: {
    getNotification () {
      this.notificationLoading = true;
      // 通知公告
      axios.get('/srmbase/noticeHeaderGsc/queryNoticeGscHeader', {
        params: {
          vendorCode: this.vendorCode,
          page: 1,
          pageSize: 10
        }
      }).then((res) => {
        this.notificationLoading = false;
        let data = res.data.data.data;
        if (data) {
          this.notificationList = data.list;
        }
      });
    },
    goRouter (name) {
      this.$router.push({
        name
      });
    },
    goNotification () {
      this.$router.push(`/wonderful2/${replaceHostName(location.hostname)}/notification-notificationList`);
    },
    goNotificationDetail ({noticeHeaderId}, item) {
      this.$router.push(`/wonderful5/${replaceHostName(location.hostname)}/noticeAnnounce-noticeAnnounceDetail/${noticeHeaderId}`);
    },
    download (docId, engDocId) {
      const hostname = window.environment.isPro ? window.location.hostname : 'gsc.midea.com';
      window.open(`//${hostname}/gscapp/supplierfile/downloadFile?docId=${this.$i18n.locale === 'en-US' ? engDocId : docId}`);
    },
    // 查询未确认的送货通知数量
    queryUnComfirmNotifyCount () {
      axios.post('/gscint/order/queryUnComfirmNotifyCount', {
        vendorCode: this.vendorCode
      })
      .then((res) => {
        this.commissionList[0].value = res.data.data.datas;
      });
    },
    // 查询已确认送货通知但数量为全部创建送货单的数量
    queryComfirmNotifyNoOrderCount () {
      axios.post('/gscint/order/queryComfirmNotifyNoOrderCount', {
        vendorCode: this.vendorCode
      })
      .then((res) => {
        this.commissionList[1].value = res.data.data.datas;
      });
    },
    // 查询未使用完数量的采购订单数量
    queryPoNoOrderCount () {
      axios.post('/gscint/order/queryPoNoOrderCount', {
        vendorCode: this.vendorCode
      })
      .then((res) => {
        this.commissionList[2].value = res.data.data.datas;
      });
    },
        /* 获取供应商信息 */
        getCurrentVendor() {
            axios.post('/gscint/vendor/getCurrentVendor')
                .then((res) => {
                    const { data = {} } = res.data;
                    localStorage.setItem('supplierInfo', JSON.stringify(data));
                    this.$store.commit('updateSupplierInfo', data);
                });
        },
        downloadFile(docId) {
            window.open(`/gscapp/supplierfile/downloadFile?docId=${docId}`);
        },
  },
  mounted() {
    this.getCurrentVendor();
    this.getNotification();
    this.queryUnComfirmNotifyCount();
    this.queryComfirmNotifyNoOrderCount();
    this.getDictByCode('INT_INDEX_FILES');
    // this.queryPoNoOrderCount();
  }
};
</script>